<!--
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-04-01 11:29:08
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-07-02 17:30:41
--> 
<template>
  <div class="identityStatus">
    <job-header-simple header_title="身份认证" :backRouter="backRouter"></job-header-simple>
    <van-image width="1.84rem" height="1.84rem" :src="imgStatus"></van-image>
    <p>{{textStatus}}</p>
    <van-button round type="info" to="/contractList">
      <template v-if="status == 2">去签署</template>
      <template v-else>查看协议</template>
    </van-button>
  </div>
</template>

<script>
import { Image, Button } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
export default {
  components: {
    [Image.name]: Image,
    [Button.name]: Button,
    jobHeaderSimple
  },
  data() {
    return {
      status: 0, //0 认证中 1 认证通过  2 认证失败
      textStatus: "认证中...",
      imgStatus: require("@/assets/identity_ing.png"),
      backRouter: "/contractList"
    };
  },
  created() {
    this.findIndividualFaceRes();
  },
  methods: {
    findIndividualFaceRes() {
      api.findIndividualFaceRes().then(res => {
        if (res.data.data === "AUTHENTICATIONOK") {
          this.status = 1;
          this.imgStatus = require("@/assets/identity_success.png");
          this.textStatus = "认证通过！";
        } else if (res.data.data === "AUTHENTICATION_FAILURE") {
          this.status = 2;
          this.imgStatus = require("@/assets/identity_error.png");
          this.textStatus = "认证失败！";
        } else {
          this.status == 0;
          this.imgStatus = require("@/assets/identity_ing.png");
          this.textStatus = "认证中...";
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.identityStatus {
  text-align: center;
  font-size: 15px;

  /deep/ .van-button {
    width: 40%;
  }

  /deep/ .van-image {
    margin-top: 20%;
    margin-bottom: 10px;
  }

  /deep/ .van-button {
    margin-top: 100px;
  }

  p {
    text-indent: 1em;
  }
}
</style>